import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import loginImg from '../Img/Login-img.jpg'
import {
  login as loginFacebook,
  logout as logoutFacebook
} from "webtonative/SocialLogin/facebook";
import {
  login as loginGoogle,
  logout as logoutGoogle
} from "webtonative/SocialLogin/google";
import {
  login as loginApple
} from "webtonative/SocialLogin/apple";
import axios from 'axios';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import logofr from '../Img/g-logo.png'
import decryptCookieData from './Functions/decryptCookieData';


const Login = ({ fetchCart }) => {
  const [phone, setPhone] = useState(''); // State for phone number
  const [password, setPassword] = useState(''); // State for password
  const [showResendButton, setShowResendButton] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);
  const [otpworld1, setOtpworld1] = useState(false);
  const [otpworld2, setOtpworld2] = useState(false);
  const [confirmObj, setConfirmObj] = useState("");
  const navigate = useNavigate();
  const [load, setLoad] = useState(true);
  const [isNativeApp, setIsNativeApp] = useState(false);
  const checkoutpage = sessionStorage.getItem("navigatepage") || ""
  const url = process.env.REACT_APP_API_URL
  console.log(checkoutpage)

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    setPhone(value);

  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoad(false)
    try {
      if (password.length < 6) {
        toast.error('Password must be at least 6 characters long.');
        setLoad(true)
        return;
      }
      // Proceed with login
      const response = await fetch(`${url}/loginuser`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: phone,
          password: password
        })
      })
      const res = await response.json();
      console.log(res);
      if (response.ok) {
        if (checkoutpage) {
          console.log(res.data.user)
          const { user_id, name } = res.user;
          await syncGuestCartToBackend(user_id, name);
          localStorage.setItem("2xgxgshdugyywerw12", JSON.stringify(res.user))
          localStorage.setItem("2xgxgshdugyywerw12gh", JSON.stringify(res.user))
          localStorage.setItem('accessToken', res.accessToken);
          localStorage.setItem('refreshToken', res.refreshToken);
          navigate(`${checkoutpage}`)
          sessionStorage.removeItem("navigatepage");
          toast.success('Login successful!');
          setLoad(true)
        } else {
          const { user_id, name } = res.user;
          console.log(res.data.user)
          await syncGuestCartToBackend(user_id, name);
          localStorage.setItem("2xgxgshdugyywerw12gh", JSON.stringify(res.user))
          localStorage.setItem('accessToken', res.accessToken);
          localStorage.setItem('refreshToken', res.refreshToken);
          navigate("/")

          toast.success('Login successful!');
          setLoad(true)
        }
      } else {
        toast.error(`${res.message}`);
        setLoad(true)
      }

      console.log('Login successful with:', { phone, password });
    } catch (error) {
      toast.error(`${error}`);
      setLoad(true)
    }
  };

  const syncGuestCartToBackend = async (user_id, user_name) => {
    const guestItems = JSON.parse(localStorage.getItem("guest_cart")) || [];
    const retained = [];

    for (const item of guestItems) {
      const syncedItem = { ...item, user_id, user_name };
      try {
        const res = await fetch(`${url}/cart`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(syncedItem),
        });

        const result = await res.json();
        if (!res.ok || result.isError) {
          if (result.msg !== "Product already in cart") retained.push(item);
        }
        fetchCart(user_id)
      } catch (error) {
        retained.push(item);
      }
    }

    if (retained.length > 0) localStorage.setItem("guest_cart", JSON.stringify(retained));
    else localStorage.removeItem("guest_cart");
  };



  const handleGoogleAuthSuccess = async (response) => {
    try {
      console.log("Google response credential:", response);
      if (!response.credential) {
        throw new Error("Google credential is missing.");
      }

      const res = await axios.post(`${url}/registeruser/api/google-signup`, {
        token: response.credential,
        main_id: process.env.REACT_APP_PERFUME_ID,
        // email: email,
      },
        {
          withCredentials: true, // ✅ This allows cookies to be set
        },
      );
      console.log(res)
      if (res.statusText === "OK" || res.status === 200) {
        if (checkoutpage) {
          console.log(res.data.user)
          const { user_id, name } = res.data.user;
          await syncGuestCartToBackend(user_id, name);
          localStorage.setItem("2xgxgshdugyywerw12gh", JSON.stringify(res.data.user))
          localStorage.setItem('accessToken', res.accessToken);
          localStorage.setItem('refreshToken', res.refreshToken);
          navigate(`${checkoutpage}`)
          sessionStorage.removeItem("navigatepage");
          toast.success('Login successful!');
        } else {
          console.log(res.data.user)
          const { user_id, name } = res.data.user;
          await syncGuestCartToBackend(user_id, name);
          localStorage.setItem("2xgxgshdugyywerw12gh", JSON.stringify(res.data.user))
          localStorage.setItem('accessToken', res.accessToken);
          localStorage.setItem('refreshToken', res.refreshToken);
          navigate("/")

          toast.success('Login successful!');
        }
      }
      // if (res.status === 201) {
      //   console.log(res);

      //   navigate("/");

      // } else if (res.status === 200) {

      //   navigate("/")


      // }
    } catch (error) {
      console.error("Google Sign-Up Error:", error.message);
      toast({
        description: "An error occurred during sign-up. Please try again.",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "top",
      });
    }
  };


  const handleLogingoggle = () => {
    if (isNativeApp) {
      // Trigger login via webtonative for native apps
      loginGoogle({
        callback: async (value) => {
          try {
            console.log("Google response credential:", value);


            const res = await axios.post(`${url}/registeruser/api/google-signup`, {
              token: value.idToken,
              main_id: process.env.REACT_APP_PERFUME_ID,
              // email: email,
            }, {
              withCredentials: true, // ✅ This allows cookies to be set
            },
            );

            if (res.statusText === "OK" || res.status === 200) {
              if (checkoutpage) {
                console.log(res.data.user)
                const { user_id, name } = res.data.user;
                await syncGuestCartToBackend(user_id, name);
                localStorage.setItem("2xgxgshdugyywerw12gh", JSON.stringify(res.data.user))
                localStorage.setItem('accessToken', res.accessToken);
                localStorage.setItem('refreshToken', res.refreshToken);
                navigate(`${checkoutpage}`)
                sessionStorage.removeItem("navigatepage");
                toast.success('Login successful!');
              } else {
                console.log(res.data.user)
                const { user_id, name } = res.data.user;
                await syncGuestCartToBackend(user_id, name);
                localStorage.setItem("2xgxgshdugyywerw12gh", JSON.stringify(res.data.user))
                localStorage.setItem('accessToken', res.accessToken);
                localStorage.setItem('refreshToken', res.refreshToken);
                navigate("/")

                toast.success('Login successful!');
              }
            }
          } catch (error) {
            console.error("Google Sign-Up Error:", error.message);
            toast({
              description: "An error occurred during sign-up. Please try again.",
              status: "error",
              duration: 5000,
              isClosable: true,
              position: "top",
            });
          }
        },
      });
    } else {
      // Handle Google Login for the website
      console.log("Redirecting to Google Login for website...");
    }
  };





  const handleGoogleAuthFailure = (error) => {
    console.error('Google authentication error:', error);
  };



  console.log(phone, password);

  return (
    <>
      <ToastContainer position="top-center" autoClose={3000} />
      <div className="login-bg">
        <div className="login-img">
          <img src={loginImg} alt="" />
        </div>
        <div className="login-box">
          <h2>Login</h2>
          <GoogleOAuthProvider clientId="970745082348-o4pbibraknlf7rea9tonp32doti23k4g.apps.googleusercontent.com">
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="number"
                placeholder="Email"
                value={phone}
                onChange={handlePhoneChange}
              />
              <input
                type="password"
                name="password"
                placeholder="Password"
                value={password}
                onChange={handlePasswordChange}
              />
              <p className="register">
                By continuing, I agree to the <Link to='/terms-and-conditions'>Terms of use</Link> & <Link to='/privacy-policy'>Privacy Policy</Link>
              </p>
              {
                load ? <button type="submit">Continue</button> :
                  <button type="button" disabled>Loading...</button>
              }
              <div className="auth-options">
                {isNativeApp ? (
                  // Show a button for native app that triggers the logout modal
                  <button
                    onClick={handleLogingoggle}
                    style={{
                      background: "white", border: "1px solid lightgray", color: "white",
                      borderRadius: "10px",
                      fontWeight: "500",
                      padding: "8px 24px",
                      marginTop: "10px",
                      boxShadow: "lg",
                      cursor: "pointer"
                    }}

                    _hover={{ background: "#f1f1f1", transform: "scale(1.05)" }} // Hover effects

                  >
                    <img
                      src={logofr}
                      alt="Google Logo"
                      boxSize="20px"
                      mr={2}
                    />
                    Sign in with Google
                  </button>

                ) : (
                  <>
                    {/* <button
                    onClick={handleLogingoggle}
                    style={{
                      background: "white", border: "1px solid lightgray", color: "white",
                      borderRadius: "10px",
                      fontWeight: "500",
                      padding: "8px 24px",
                      marginTop: "10px",
                      boxShadow: "lg",
                      cursor: "pointer"
                    }}

                    _hover={{ background: "#f1f1f1", transform: "scale(1.05)" }} // Hover effects
                  >
                    <img
                      src={logofr}
                      alt="Google Logo"
                      // boxSize="20px"
                      // mr={2}
                    />
                    Sign in with Google
                  </button> */}

                    <GoogleLogin
                      onSuccess={handleGoogleAuthSuccess}
                      onError={handleGoogleAuthFailure}
                    />
                  </>
                  // <Button
                  //   onClick={handleLogingoggle}
                  //   bg="white" // Background color
                  //   color="black" // Text color
                  //   fontWeight="500" // Bold text
                  //   borderRadius="md" // Medium border radius
                  //   border="1px solid lightgray" // Optional border
                  //   padding="8px 24px" // Padding for size
                  //   _hover={{ background: "#f1f1f1", transform: "scale(1.05)" }} // Hover effects
                  //   boxShadow="lg" // Optional shadow for elevation
                  //   mt={4}
                  // >
                  //   <Image
                  //     src="https://developers.google.com/identity/images/g-logo.png"
                  //     alt="Google Logo"
                  //     boxSize="20px"
                  //     mr={2}
                  //   />
                  //   Sign in with Google
                  // </Button>

                )}
              </div>


            </form>
          </GoogleOAuthProvider>

          {/* <p className="divider">Or sign in with</p>
                    <div className="google">
                        Sign in with Google
                    </div> */}
          <p className="register">
            Don't have an account? <Link to='/register'>Register now</Link>
          </p>
          <Link to='/reset'><p className="reset-btn">Having trouble in sign in?</p></Link>
        </div>
      </div>
    </>
  );
};

export default Login;
